import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { ExtrasRepository } from '../repositories/extras.repository';
import { ExtrasInterface } from '../models/extras.model';

interface GetExtrasParams {
    id: number;
    coupon?: string;
    category?: string;
    pickupDate?: string;
    returnDate?: string;
}

export class getExtrasUseCase
    implements UseCase<GetExtrasParams, ExtrasInterface>
{
    constructor(private readonly repository: ExtrasRepository) {}

    execute(params: GetExtrasParams): Observable<ExtrasInterface> {
        return this.repository.getExtras(
            params.id,
            params.coupon,
            params.category,
            params.pickupDate,
            params.returnDate,
        );
    }
}
